import { motion, useTransform } from "framer-motion";
import { useStageMotion } from "./useStageMotion";
import StormLayers from "@/components/cinema/StormLayers";

const ASSET = process.env.PUBLIC_URL || "";
const STORY_LIGHTNING_EVERY = [4000, 9000];

function StoryImage({ progress, stage, index, total, armed }) {
  const { opacity } = useStageMotion(progress, index, total, 0.07);
  const s = index / total;
  const e = (index + 1) / total;
  const scale = useTransform(progress, [s - 0.07, e + 0.07], [1.14, 1.0]);
  return (
    <motion.img
      src={armed ? `${ASSET}${stage.img}` : undefined}
      alt={`Stage ${stage.n}: ${stage.title}`}
      style={{ opacity, scale }}
      className="absolute inset-0 w-full h-full object-cover will-change-transform"
      decoding="async"
      draggable={false}
      data-testid={`story-image-${index + 1}`}
    />
  );
}

export default function StoryScene({ progress, stages, armed, activeIndex }) {
  const storm = useTransform(progress, [0.12, 0.3], [1, 0]);
  const cool = useTransform(progress, [0, 0.6], [0.35, 0]);
  const warm = useTransform(progress, [0.72, 1], [0, 0.3]);

  return (
    <div className="story-scene" data-testid="story-scene" data-stage={activeIndex + 1}>
      {stages.map((st, i) => (
        <StoryImage key={st.key} progress={progress} stage={st} index={i} total={stages.length} armed={armed} />
      ))}
      <motion.div className="absolute inset-0 pointer-events-none" style={{ opacity: storm }} data-testid="story-storm" aria-hidden>
        {armed && <StormLayers active={activeIndex === 0} intensity={1.25} lightningEvery={STORY_LIGHTNING_EVERY} />}
      </motion.div>
      <motion.div className="absolute inset-0 bg-[#0b2f6b] mix-blend-multiply" style={{ opacity: cool }} aria-hidden />
      <motion.div className="absolute inset-0 bg-[#ffb35a] mix-blend-soft-light" style={{ opacity: warm }} aria-hidden />
      <div className="story-gradient" aria-hidden />
      <div className="grain absolute inset-0" aria-hidden />
    </div>
  );
}
